import React from "react";

export default function Cc() {
  return (
    <>
      <section className="section cc shadow-sm lazyloaded">
        <center>
          <h3 style={{ fontSize: "1.2rem" }}>Certified Green By IGBC</h3>
        </center>
        <img src="images/cc.jpeg" alt="" />
      </section>
    </>
  );
}
